import { Table } from 'antd';
import { columns } from './columns';

export default function CustomTree({
  treeData,
  checkedKeys,
  onCheck,
}: {
  treeData: any;
  expandedKeys: any;
  onExpand: (key: any, expanded: boolean) => void;
  checkedKeys: any;
  onCheck: (key: any, checked: boolean) => void;
}) {
  return (
    <Table
      dataSource={treeData}
      columns={columns({ checkedKeys, onCheck })}
      pagination={false}
    />
  );
}
